import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { HIGHLIGHTS } from "../../data/content";
import { useOrder } from "../../context/OrderContext";
import { Reveal } from "./Reveal";

const Card = ({ item, index }) => {
  const { openOrder } = useOrder();
  return (
    <Reveal
      delay={index * 0.06}
      className={`group relative overflow-hidden rounded-3xl border border-white/8 bg-surface ${item.span} min-h-[260px] lg:min-h-0`}
    >
      <button onClick={openOrder} className="absolute inset-0 h-full w-full text-left" data-testid={`highlight-${item.id}`}>
        <img
          src={item.img}
          alt={item.name}
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/40 to-transparent" />

        <span className="absolute left-5 top-5 rounded-full bg-gold/90 px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-ink">
          {item.tag}
        </span>
        <span className="absolute right-5 top-5 grid h-10 w-10 place-items-center rounded-full border border-white/25 bg-black/30 text-cream backdrop-blur-sm transition-all duration-300 group-hover:bg-gold group-hover:text-ink group-hover:border-gold">
          <ArrowUpRight size={18} />
        </span>

        <div className="absolute inset-x-0 bottom-0 p-5 sm:p-6">
          <div className="flex items-end justify-between gap-3">
            <h3 className="font-display text-2xl sm:text-3xl font-semibold text-cream">{item.name}</h3>
            <span className="shrink-0 font-display text-lg font-semibold text-gold">{item.price}</span>
          </div>
          <p className="mt-1.5 max-w-md text-sm text-cream/65 leading-relaxed">{item.desc}</p>
        </div>
      </button>
    </Reveal>
  );
};

export const MenuHighlights = () => {
  return (
    <section className="relative mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32">
      <div className="mb-10 flex flex-wrap items-end justify-between gap-6">
        <div>
          <Reveal>
            <p className="text-[11px] uppercase tracking-[0.24em] text-gold font-semibold">Our Top Sellers</p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-3 font-display text-4xl sm:text-6xl font-semibold tracking-tight text-cream">
              Top sellers
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <p className="max-w-sm text-sm sm:text-base text-cream/60 leading-relaxed">
            The five dishes Winnipeg orders again and again. Tap any dish to start your order.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:gap-5 lg:grid-cols-12 lg:auto-rows-[248px]">
        {HIGHLIGHTS.map((item, i) => (
          <Card key={item.id} item={item} index={i} />
        ))}
      </div>
    </section>
  );
};

export default MenuHighlights;
